import React, { Component } from 'react';
import { connect } from 'react-redux';
import './css/AddCard.css';
import { getWebViewHtml } from '../action/webViewContentAction.js';
import { getBankCardType } from '../action/myCardsAction.js';
import { List, InputItem } from 'antd-mobile/lib';
import { createForm } from 'rc-form';
import Util from '../util';
import { getTempInfo,getStorage} from '../common.js';
import { Toast } from 'antd-mobile/lib';
import NavigatorMain from './NavigatorMain';
import { myAddCardText } from '../action/publicAction';
import { hashHistory } from 'react-router';

class AddCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name:'',
      btnFlag:false
    };
  }
  async componentWillMount(){
    document.title = "添加银行卡"
    let userInfo=await getStorage('currentUserInfo')
    this.setState({
      name:userInfo.userMsg.name,
      mobileNo:userInfo.mobileNo
    })

  }
  onChangeText(e){
    this.props.dispatch(myAddCardText(e.target.value));
  }
  async handleGetBankCardType(){
    Toast.loading('', 2);
    let params = {
      token: await getTempInfo('shortToken'),
      bankCardNo: this.props.addCardText,
    };
    this.props.dispatch(getBankCardType(params, (content)=>this.getBankCardTypeSuccess(content), (msg)=>this.getBankCardTypeError(msg)));
  }
  async getBankCardTypeSuccess(content){
    let data=await getStorage("currentUserInfo")
    hashHistory.push({
      pathname:'/AddPhone',
      state:{
        length:window.history.length,
        content:content,
        bankAccountName: data.userMsg.name,   
        certType: data.userMsg.certType,
        certNo: data.userMsg.certNo,
        bankAccountShowNo: this.props.addCardText,
        cardName: content.cardName,
        bankCode: content.bankCode,
        fundCode:this.props.location.state.fundCode,
        mobileNo:data.userMsg.mobileNo
      }
    })
   
    
  }
  getBankCardTypeError(msg){
    Toast.info( msg, Util.ToastTime );
  }
  render(){
    let flag=Util.regular1.test(this.props.addCardText)
    return (
        <div className="container" >
        <NavigatorMain>
          <div className="header black">
            <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
            <div>添加银行卡</div>
            <div></div>
          </div>
        </NavigatorMain>
          <div className='content'>
           <div className='share'>
              <div className='shareTitle'>
                请绑定您本人的银行卡
              </div>
            </div>
            <div className='contentHeader' style={{borderBottom:'1px solid #eaeaea'}}>
              <div>持卡人</div>
              <div>{this.state.name}</div>
            </div>
            <div className='contentHeader'>
              <p >卡号</p>
              <input autocomplete="off" style={{WebkitFlex:1,textAlign:'right'}} onChange={(e)=>this.onChangeText(e)} type="text" value={this.props.addCardText} placeholder={'请输入卡号'} />
              
            </div>
            {
              flag?<div onClick={()=>this.handleGetBankCardType()} className='btn'>下一步</div>:
              <div  className='btn btn-gray'>下一步</div>
            }
            <div className='addCard-tipBox'>
              <p>温馨提示 :</p>
              <p>如果您的银行卡是由交通银行、浦发银行、平安银行或邮储银行发行的。您需要先通过电脑访问银联官网开通该卡的银联在线支付，网址：https://www.95516.com/static/union/pages/card/openFirst.html?entry=openPay。开通成功后，再通过APP绑定该类银行卡即可。为此造成的不便，敬请谅解。</p>
            </div>
          </div>
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    addCardText:state.addCardText
  }
}
export default connect(mapStateToProps)(AddCard);



// WEBPACK FOOTER //
// ./src/components/AddCard.js